import React from 'react';

import getEntityUrl from 'url-constructors/getEntityUrl';

import Layout from 'components/styled/Layout/Layout';
import Anchor from 'components/base/Anchor/Anchor';
import PlaylistKPIs from 'components/data-containers/KPIs/Playlist/PlaylistKPIs';
import { MessageWithSmallMargin } from 'components/base/Message/Message';
import { EntityTypes } from 'context/entityContext';

export type PlaylistProps = {
  artist: {
    entityType: EntityTypes;
    entityId: string | undefined;
  };
  topic: string;
};

const Playlist: React.FC<PlaylistProps> = ({
  artist: { entityType, entityId },
  topic,
}) => {
  return (
    <div>
      <PlaylistKPIs />

      <Layout.MaxWidth>
        <MessageWithSmallMargin>
          Select an&nbsp;
          <Anchor
            withChevron={false}
            isNewDesign
            to={getEntityUrl({
              entityType,
              entityId,
              topic,
            })}
          >
            artist&#39;s track
          </Anchor>
          &nbsp;to see the playlist table.
        </MessageWithSmallMargin>
      </Layout.MaxWidth>
    </div>
  );
};

export default Playlist;
